/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RangeDTO
 */
export interface RangeDTO {
    /**
     * 
     * @type {number}
     * @memberof RangeDTO
     */
    from: number;
    /**
     * 
     * @type {number}
     * @memberof RangeDTO
     */
    to: number;
}

/**
 * Check if a given object implements the RangeDTO interface.
 */
export function instanceOfRangeDTO(value: object): value is RangeDTO {
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function RangeDTOFromJSON(json: any): RangeDTO {
    return RangeDTOFromJSONTyped(json, false);
}

export function RangeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RangeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'],
        'to': json['to'],
    };
}

export function RangeDTOToJSON(value?: RangeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'from': value['from'],
        'to': value['to'],
    };
}

